import { fromJS } from 'immutable';

import * as constants from './global-errors-display-constants';

const initialState = fromJS({
  errorType: '',
  errorMessage: '',
  noAccessDialog: false,
  routeBackOnDismiss: false,
  requestingAccessToFeature: '', // CAPITALIZE FIRST LETTER OF EACH WORD
  requestAccessData: {},
  requestAccessError: '',
  requestingAccess: false,
});

export function globalErrors(state = initialState, { type, payload, errorType }) {
  switch (type) {
    case constants.ERROR_TRIGGERED:
      return state.set('errorType', errorType)
                  .merge(fromJS(payload));
    case 'SUBMIT_NEWSFEED_POST_FAILED':
      return state.set('errorMessage', 'Submit Post Failed');
    case 'GET_NEWSFEED_FAILED':
      return state.set('errorMessage', 'Get Feeds Failed');
    case 'DELETE_POST_FAILED':
      return state.set('errorMessage', 'Deleting Post Failed');
    case 'GET_POST_FAILED':
      return state.set('errorMessage', 'Unable To Locate Post');
    case 'GET_NEWSFEED_POSTS_FOR_OWNER_FAILED':
      return state.set('errorMessage', 'Unable to Get Posts');
    case 'UPDATE_POST_FAILED':
      return state.set('errorMessage', 'Unable To Update Post');
    case constants.REQUEST_ACCESS_STARTED:
      return state.set('requestingAccess', true);
    case constants.REQUESTED_ACCESS:
      return state.set('requestingAccess', false);
    case constants.REQUEST_ACCESS_FAILED:
      return state.set('requestingAccess', false)
      .set('requestAccessError', payload);
    case constants.CLEAR_STORE:
      return initialState;
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/app/stores/global-errors-display/global-errors-display-reducer.js